(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('LoginController', LoginController);

    LoginController.$inject = [
        '$state',
        'authorization',
        '$stateParams',
        '$timeout', 
        '$q',
        'userService',
        'genericDataService',
        'preferences',
        'reportService',
        '$rootScope',
        'messagingService'
    ];

    function LoginController(
        $state,
        authorization,
        $stateParams,
        $timeout, 
        $q,
        userService,
        genericDataService,
        preferences,
        reportService,
        $rootScope,
        messagingService
    ) {

        var vm = this;

        vm.doLogin = doLogin;
        vm.loading = $stateParams.loading;
        vm.clicked = false; 
        vm.failed = false; 

        (function () {
            if (vm.loading) { //Loading screen
                loadInitialData();
            } 
        })();


        function doLogin(user, pass) {
            vm.clicked = true; 
            vm.failed = false; 
            authorization.doLogin(user, pass).then(function () {
                redirectForward();
            }, function () {
                vm.clicked = false; 
                vm.failed = true; 
                // alert('Failed Login'); //TODO: Failed login logic!
            });
        }

        function loadInitialData() {
            $q.all([
                //userService.getUserData(),
                userService.loadWithDefaults(),
                
                //byArnau
                // genericDataService.getPerfilesDeFlotaPorUsuario(),
                // preferences.getCompanyPrefs(),
                // reportService.getAvailableReports(),
                
                //GenericData
                //byArnau
                // genericDataService.getEmpresas(),
                // genericDataService.getVehicleBrands(),
                // genericDataService.getVehicleModel(),
                // genericDataService.getTiposSubFlota(),
                // genericDataService.getTiposFlota(),
                // genericDataService.getVehicleColors(),
                // genericDataService.getBases(),
                // genericDataService.getTalleres(),
                // genericDataService.getOperarios(),
                // genericDataService.getFlota(),
                // genericDataService.getTiposPago(), 
                // genericDataService.getColaboradores(),
                // genericDataService.getTiposOrden(),
                
                
                //fakeDataCall()

            ]).then(function(values){
                authorization.hasLoaded = true;

                //byArnau
                // var ordenView = $state.router.stateProvider.stateRegistry
				// 	.states['flota.ordenes.nueva'].views.ordenesContainer;

				// var ordenViewEditar = $state.router.stateProvider.stateRegistry
				// 	.states['flota.ordenes.editar'].views.ordenesContainer;

                // switch(preferences.prefs.sector) {
                //     case 'GRU':
				// 		ordenView.templateUrl = 'app/views/flota/ordenes/form_ordenGRU.html'; 
				// 		ordenViewEditar.templateUrl = 'app/views/flota/ordenes/form_ordenGRU.html';
                //         break;
                //     case 'TAX':
				// 		ordenView.templateUrl = 'app/views/flota/ordenes/form_ordenTAX.html';
				// 		ordenViewEditar.templateUrl = 'app/views/flota/ordenes/form_ordenTAX.html';
                //         break;
                //     default:
				// 		ordenView.templateUrl = 'app/views/flota/ordenes/form_ordenGRU.html';
				// 		ordenViewEditar.templateUrl = 'app/views/flota/ordenes/form_ordenGRU.html';
                // }

                // messagingService.init();
                // messagingService.connect();

                redirectForward();
            });
        }

        function fakeDataCall(){
            var deferred = $q.defer();
            $timeout( function(){
                deferred.resolve('Fake call OK');
            }, 3000 );
            return deferred.promise;
        }

        function redirectForward() {
            $state.go($stateParams.redirectState, $stateParams.redirectParams);
        }
    }
})();